/*
 * File: RecentSignal.tsx
 * Project: a-a
 * File Created: Monday, 3rd November 2025 11:52:44 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 13th November 2025 8:24:56 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import zeplinColor from '../../../../../theme/Color';
import styles from './RecentSignal.module.css';

const RecentSignal = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: `1px solid ${zeplinColor.Neutral8}`,
        borderRadius: '14px',
        padding: '16px',
        display: 'flex',
        gap: '16px',
        flexDirection: 'column',
        flex: 1,
        overflowY: 'scroll',
        paddingBottom: { xs: '2rem' },
      }}
    >
      {!data?.length && !loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            gap: '32px',
          }}
        >
          {' '}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '24px',
              width: '100%',
            }}
          >
            <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
            <Typography
              variant='responsiveHeading3'
              color={zeplinColor.BasicBlack}
              sx={{ marginTop: '0px' }}
            >
              No recent signals.
            </Typography>
          </Box>
        </Box>
      ) : (
        <>
          <Typography sx={{ fontSize: '14px', fontWeight: 510 }}>Recent Signals</Typography>
          <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
            Last 30 days
          </Typography>
          <List>
            {loading ? (
              [1, 2, 3, 4].map((val) => (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '100%',
                    backgroundColor: zeplinColor.Neutral4,
                    // Optionally adjust other styles here
                  }}
                />
              ))
            ) : (
              <></>
            )}
            {data?.map((val: any) => (
              <ListItem sx={{ padding: '0px 0px 0px 0px', gap: '10px', alignItems: 'flex-start' }}>
                <ListItemIcon sx={{ width: '5px', minWidth: '0px' }}>
                  <FiberManualRecordIcon
                    fontSize='small'
                    sx={{ color: zeplinColor.BasicBlack, width: '5px' }}
                  />
                </ListItemIcon>
                <ListItemText
                  children={
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        // alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      {' '}
                      <Typography
                        variant='responsiveBody3'
                        color={zeplinColor.Neutral10}
                        sx={
                          {
                            //   maxWidth: { xs: '30rem', xl: '35rem' },
                            //   textOverflow: 'ellipsis',
                            //   overflow: 'hidden',
                            //   whiteSpace: 'nowrap',
                          }
                        }
                      >
                        {val?.summary}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default RecentSignal;
